import React, { useEffect, useState } from 'react';
import {
  Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, TextField,
} from '@mui/material';
import { rhAPI } from '../../services/api';
import { apiError } from '../../utils/format';
import { TYPES_CONGE, todayIso } from '../../utils/rh';

const CongeDialog = ({ open, value, employes, soldes = [], onClose, onSaved }) => {
  const [f, setF] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setError('');
      setF({ employe_id: '', type: 'ANNUEL', date_debut: todayIso(), date_fin: todayIso(), motif: '', approuver: false, ...value });
    }
  }, [open, value]);

  if (!f) return null;
  const solde = soldes.find((s) => s.id === Number(f.employe_id));
  const save = async () => {
    setSaving(true); setError('');
    try {
      const r = f.id ? await rhAPI.updateConge(f.id, f) : await rhAPI.createConge(f);
      onSaved(r.data.message + (r.data.nb_jours ? ` (${r.data.nb_jours} jours ouvrés)` : ''));
    } catch (e) { setError(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{f.id ? 'Modifier la demande' : 'Nouveau congé'}</DialogTitle>
      <DialogContent sx={{ display: 'grid', gap: 2, pt: '8px !important' }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField select label="Employé" value={f.employe_id} required
          helperText={solde && f.type === 'ANNUEL' ? `Solde de congés annuels : ${solde.solde} jours${solde.en_attente ? ` (${solde.en_attente} en attente)` : ''}` : ' '}
          onChange={(e) => setF({ ...f, employe_id: e.target.value })}>
          {employes.map((e) => <MenuItem key={e.id} value={e.id}>{e.nom} {e.prenom} — {e.matricule}</MenuItem>)}
        </TextField>
        <TextField select label="Type" value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}>
          {Object.entries(TYPES_CONGE).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
        </TextField>
        <TextField type="date" label="Premier jour" value={f.date_debut} InputLabelProps={{ shrink: true }}
          onChange={(e) => setF({ ...f, date_debut: e.target.value, date_fin: f.date_fin < e.target.value ? e.target.value : f.date_fin })} />
        <TextField type="date" label="Dernier jour (inclus)" value={f.date_fin} InputLabelProps={{ shrink: true }}
          onChange={(e) => setF({ ...f, date_fin: e.target.value })} />
        <TextField label="Motif / commentaire" value={f.motif || ''} multiline minRows={2} onChange={(e) => setF({ ...f, motif: e.target.value })} />
        {!f.id && (
          <FormControlLabel control={<Checkbox checked={f.approuver} onChange={(e) => setF({ ...f, approuver: e.target.checked })} />}
            label="Approuver immédiatement" />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button variant="contained" disabled={saving || !f.employe_id} onClick={save}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CongeDialog;
